// Copyright (c) Ensho Health, 2021 to present

import { GraphQLClient } from 'graphql-request';

const WORKFLOW_ENDPOINT = process.env.REACT_APP_API + '/wf';
const workflowClient = new GraphQLClient(WORKFLOW_ENDPOINT, { headers: {} });
const PRIVATE_ENDPOINT = process.env.REACT_APP_API + '/priv';
const privateClient = new GraphQLClient(PRIVATE_ENDPOINT, { headers: {} });

export { workflowClient, privateClient };
